import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import imgixConfig from 'Config/imgix';

import 'Components/Banner/FantasyVerseStripBanner/FantasyVerseStripBanner.scss';

export default function FantasyVerseStripBanner() {
  return (
    <Link to="/fantasyverse" className="FantasyVerseStripBanner">
      <div className="FantasyVerseStripBanner__content">
        <div className="FantasyVerseStripBanner__text">
          <FormattedMessage
            id="fantasyverse-strip-banner.text"
            defaultMessage="Part of the"
          />
        </div>
        <div className="FantasyVerseStripBanner__logo">
          <img
            src={`https://fanatical.imgix.net/production/brand/fantasyverse-logo-white.svg?${imgixConfig}&fit=crop`}
            alt="FantasyVerse"
            className="FantasyVerseStripBanner__logo__img"
          />
        </div>
      </div>
    </Link>
  );
}
